import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import RatingDistributionResponse from '../responses/RatingDistributionResponse'

const useRatingDistribution = () => {
	const [data, setData] = useState<RatingDistributionResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		BooksitoutServer
			.get(`/v1/statistics/rating-distribution`)
			.then(res => setData(res.data))
			.finally(() => setIsLoading(false))
	}, [])

	return [data, isLoading] as const
}

export default useRatingDistribution
